export enum OptimizelyExperiments {
  emailChangeEnabled = 'opex_email_change',
  croMultiItemCart = 'cro_multi_item_cart',
  securePhoneNumberChangeEnabled = 'csx_secure_phone_number_change',
  croLPFreePreviewAfterSignUpLogIn = 'cro_offer_lp_free_preview_after_sign_up_log_in',
  croAlwaysOnNewMobileBooking = 'cro_lpc_new_mobile_booking',
  croFlexibleFlightFares = 'cro_flexible_flight_fares',
  paymentsDepositOptionForHotelsAbove1999V2 = 'payments_deposit_option_for_hotels_above_1999_v2',
  carHireBundledDiscountUpcomingOrderHomepageCarousel = 'car_hire_bundled_discount_upcoming_order_homepage_carousel',
  croPopularOptionBookingRemaining = 'cro_popular_option_booking_remaining',
  searchRankingValueTestExpanded = 'search_ranking_value_test_expanded',
  growthShowOfferUrgencyCountdownLabel = 'growth_force_show_offer_urgency_countdown_label',
  croBundledFlexibleFlightFaresV2 = 'cro_bundled_flexible_flight_fares_v2',
  paymentsPaypalButtonOrder = 'payments_paypal_button_order',
  isCfmrEnabledForInternationalHotels = 'cro_cfmr_vs_insurance_for_international_hotels',
  searchTileCompactFeatures = 'search_tile_compact_features',
  croDisableKrisFlyer = 'cro_disable_krisflyer',
  croHideHomepageSearchEmergingMarkets = 'cro_hide_homepage_search_emerging_markets',
  croUseLuxPlusPriceForMembers = 'cro_use_luxplus_price_for_members',
  paymentsDebitCardMerchantFeesV3 = 'payments_debit_card_merchant_fees_v3',
  croWePriceMatchOfferPageTag = 'cro_we_price_match_tag',
  croChangeImageOnHover = 'cro_change_image_on_hover',
  croInclusionChipsOnHomepageHeroCarousels = 'cro_inclusion_chips_on_homepage_hero_carousels',
  croAlternateHomepageOrder = 'cro_alternate_homepage_order',
  searchRedirectPropertySpecificSearch = 'search_redirect_property_specific_search',
  lereTwoTowersInOfferPage = 'lere_two_towers_in_offer_page',
  searchWhiteLabelsRanking = 'search_whitelabels_ranking',
  croRemoveRequiredPhoneAndPostcodeWhitelabels = 'cro_remove_required_phone_and_postcode_whitelabels',
  lereTwoTowersHomePageHeroCarousel = 'lere_two_towers_home_page_hero_carousel',
  lereNonAUTwoTowersHomePageHeroCarouselV2 = 'lere_non_au_two_towers_home_page_hero_carousel_v2',
  croAbandonedCartPopUpEnabled = 'cro_abandoned_cart_pop_up',
  croBeforeUnloadWarningInCheckout = 'cro_beforeunload_warning_in_checkout',
}

export enum OptimizelyFeatureFlags {
  lebtPinnedFlightDetails = 'lebt_pinned_flight_details',
  lebtServiceFeesEnabled = 'lebt_service_fees',
  lebtOrderSchemaV2 = 'lebt_order_schema_v2',
  lebt_hotel_loyalty = 'lebt_hotel_loyalty',
  lebtTypeaheadIII = 'lebt_typeahead_iii',
  /** Enables new document-aware invoice download behaviour across Customer Portal **/
  lebtOrderDocumentsDownload = 'lebt_order_documents_download',
  luxLoyaltyFeatureToggle = 'lux_loyalty_feature_toggle',
  luxPlusFeatureToggle = 'luxplus_feature_toggle',
  luxPlusToursToggle = 'luxplus_tours_toggle',
  luxPlusDiscountedInsuranceBenefit = 'lux_plus_discounted_insurance_benefit',
  luxPlusDiscountedBookingProtectionBenefit = 'lux_plus_discounted_booking_protection_benefit',
  luxPlusLppPricingEnabled = 'luxplus_lpp_pricing_enabled',
  luxPlusCruiseInclusionsEnabled = 'lux_plus_cruise_inclusions',
  luxPlusDiscountedExperiencesBenefit = 'lux_plus_discounted_experiences_benefit',
  allowPhoneNumberLogin = 'allow_phone_number_login',
  promoAppBanner = 'app_banner_targeted_delivery',
  CSAgentsAutoQuote = 'cro_cs_agents_auto_quote',
  tourReviewsEnabled = 'cro_tour_reviews',
  toursRequestAgentCallbackEnabled = 'csx_tours_request_agent_callback',
  hotelsAndVillasRequestAgentCallbackEnabled = 'csx_hotels_and_villas_request_agent_callback',
  upsellTilesFeatureToggle = 'cro_upsell_on_homepage_and_my_escapes',
  croNewFlightsSaleCarouselEnabled = 'cro_flights_sale_carousel',
  croTravelPreferencesModalEnabled = 'cro_travel_preferences_modal',
  opexTermsAndConditionsModal = 'terms_and_conditions_modal',
  croWebPushNotificationPrompt = 'cro_web_push_notification_prompt',
  opexFraudOrdersOtp = 'opex_fraud_orders_otp',
  payIdTargetedRelease = 'pay_id_targeted_release',
  accomUsePropertyPageRatesEndpoint = 'accom_use_property_page_rates_endpoint',
  isGeneratedTripsEnabled = 'is_generated_trips_enabled',
  marketplacePage = 'marketplace_page',
  carHireBundledDiscount = 'car_hire_bundled_discount',
  lereHeroCarouselEnabled = 'lere_hero_carousel',
  opexHotelAddExtraGuestsEnabled = 'hotel_add_extra_guests',
  croNewMobileMultipleRoom = 'cro_new_mobile_multiple_room',
  flightsEnableSabreContent = 'flights_enable_sabre_content',
  loyaltyLuxPlusRenewalReward = 'loyalty_lux_plus_renewal_reward',
  loyaltyPointsDeductionWarning = 'loyal_points_deduction_warning',
  croInsuranceXCoverEnabled = 'cro_insurance_xcover_enabled',
  croCsCartComparison = 'cro_cs_cart_comparison',
  croPackageUpgradeLibEnabled = 'cro_package_upgrade_lib_enabled',
  lebtFlightCancellation = 'lebt_flight_cancellation',
  lebtHotelChangeDateEnabled = 'lebt_hotel_change_date_enabled',
  lebtHotelUpdateRoomEnabled = 'lebt_hotel_update_room_enabled',
  lebtNdcFlightsToggle = 'lebt_ndc_flights_toggle',
  lebtFFNSeatSelection = 'lebt_ffn_seat_selection',
  lebtUserGroupsEnabled = 'lebt_user_groups_enabled',
  lebtItemPoliciesEnabled = 'lebt_item_policies_enabled',
  lebtSociete = 'lebt_societe'
}
